import { onDestroy } from "svelte";
import objectHash from "object-hash";
export const clamp = (val, min, max) => Math.max(Math.min(val, max), min);
export const hash = (_) => objectHash.sha1(_);
export const focusout = () => {
    if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
    }
};
export const random = (from, to) => {
    if (!to) {
        return Math.random() * from;
    }
    return from + Math.random() * (to - from);
};
const makeChars = () => {
    const retval = [
        32,
        187,
        189,
        219,
        221,
        191,
        192,
        186,
        222,
        188,
        190,
        220, // \
    ];
    //number keycodes
    for (let i = 48; i < 58; ++i) {
        retval.push(i);
    }
    //characters
    for (let i = 65; i < 91; ++i) {
        retval.push(i);
    }
    return retval;
};
export const charKeyCodes = makeChars();
export const randomId = (digit = 16) => {
    let result = "";
    let characters = 
    // 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    let charactersLength = characters.length;
    for (let i = 0; i < digit; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
};
export function onInterval(callback, milliseconds) {
    const interval = setInterval(callback, milliseconds);
    onDestroy(() => {
        clearInterval(interval);
    });
}
//cookies, https://www.w3schools.com/js/js_cookies.asp
export function setCookie(cname, cvalue, exdays) {
    // if(getCookie(cname)){
    //   throw new Error(`Same cookie name already exist : ${cname}`);
    // }
    let retval = cname + "=" + cvalue + ";";
    if (exdays) {
        const d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        let expires = "expires=" + d.toUTCString();
        retval = retval + expires + ";path=/";
    }
    document.cookie = retval;
}
//return undefined when not found
export function getStorage(cname) {
    return localStorage.getItem(cname);
}
export function setStorage(cname, value) {
    localStorage.setItem(cname, value);
}
export function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return undefined;
}
export const getBase64 = (fileBlob) => {
    var reader = new FileReader();
    reader.readAsDataURL(fileBlob);
    reader.onload = function () {
        console.log(reader.result);
    };
    reader.onerror = function (error) {
        console.log("Error: ", error);
    };
};
